export default "./../../assets/images/email/uqres-logo-alt.png";